import Cookies from 'js-cookie'

const state = {
    // ...其他配置项省略...
    // set locale 设置默认初始化的语言 i18n
    language: Cookies.get('language') || 'zh',
    screenSize: 'lg'
}

const mutations = {
    // ...其他配置项省略...
    SET_LANGUAGE: (state, language) => {
        state.language = language
        Cookies.set('language', language)
    },
    SET_SCREEN_SIZE: (state, size) => {
        state.screenSize = size
    }
}

const actions = {
    // ...其他配置项省略...
    setLanguage({ commit }, language) {
        commit('SET_LANGUAGE', language)
    },
    setScreenSize({ commit }, width) {
        if (width >= 1920) {
            commit('SET_SCREEN_SIZE', 'xl')
        } else if (width >= 1200) {
            commit('SET_SCREEN_SIZE', 'lg')
        } else if (width >= 992) {
            commit('SET_SCREEN_SIZE', 'md')
        } else if (width >= 768) {
            commit('SET_SCREEN_SIZE', 'sm')
        } else {
            commit('SET_SCREEN_SIZE', 'xs')
        }


    },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}




// WEBPACK FOOTER //
// ./src/store/modules/app.js